module.exports = __webpack_public_path__ + "img/temple.874f8d0d.png";